import Vue from 'vue';
import LocalStorage from "../../libs/LocalStorage";

export default {
  state: {
    slicerTypeByPrinterType: LocalStorage.getValue(LocalStorage.SLICER_BY_PRINTER_TYPE_KEY, true, {}),
    slicerTypeByFile: LocalStorage.getValue(LocalStorage.SLICER_BY_FILE_KEY, true, {})
  },

  mutations: {
    UPDATE_SLICER_TYPE_BY_PRINTER_TYPE(state, {printerTypeId, slicerType}) {
      Vue.set(state.slicerTypeByPrinterType, printerTypeId, slicerType);
    },
    UPDATE_SLICER_TYPE_BY_FILE(state, {fileId, slicerType}) {
      Vue.set(state.slicerTypeByFile, fileId, slicerType);
    }
  },

  actions: {
    saveSlicerTypeByPrinterType(context, {printerTypeId, slicerType}) {
      context.dispatch('UPDATE_SLICER_TYPE_BY_PRINTER_TYPE', {printerTypeId, slicerType});
      LocalStorage.setValue(LocalStorage.SLICER_BY_PRINTER_TYPE_KEY, context.state.slicerTypeByPrinterType);
    },
    saveSlicerTypeByFile(context, {fileId, slicerType}) {
      context.dispatch('UPDATE_SLICER_TYPE_BY_FILE', {fileId, slicerType});
    }
  },

  getters: {
    getSlicerTypeByPrinterTypeId: state => printerTypeId => {
      return state.slicerTypeByPrinterType[printerTypeId];
    },
    getSlicerTypeByFileId: state => fileId => {
      return state.slicerTypeByFile[fileId];
    }
  }
}
